import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { CALENDAR_MODE, DAY_MODE } from "../constants/MODE_LIST.js";
import MultiplexDay from "./day/MultiplexDay.js";
import MultiplexCalendar from "./calendar/MultiplexCalendar.js";
import { Box } from "@mui/material";

const MultiplexResolver = () => {

    const {live, liveDates, liveCompetitionsDays} = useOutletContext();

    const { idMatch, id, mode, date } = useParams();
    
    if(mode === DAY_MODE)
        return <Box>
                <MultiplexDay live={live} liveCompetitionsDays={liveCompetitionsDays}/>
                <Outlet context={{ live }}/>
            </Box>

    if(mode === CALENDAR_MODE)
        return <Box>
            <MultiplexCalendar live={live} liveDates={liveDates}/>
            <Outlet context={{ live }}/>
        </Box>

}

export default MultiplexResolver